import i18n from 'i18next'
import { DataClass } from 'scrivito'

type ValuesByAttribute = Record<string, string[]>
type ValuesByDataClass = Record<string, ValuesByAttribute>

type LocalizerByValue = Record<string, string>
type LocalizersByAttribute = Record<string, LocalizerByValue>
type LocalizersByDataClass = Record<string, LocalizersByAttribute>
type LocalizersByLocale = Record<string, LocalizersByDataClass>

const values: ValuesByDataClass = {}
const localizers: LocalizersByLocale = {}

export function provideDataValues(
  dataClass: DataClass,
  valuesByAttribute: Record<string, string[]>,
): void {
  const dataClassName = dataClass.name()!
  values[dataClassName] = valuesByAttribute
}

export function dataValues(
  dataClass: DataClass,
  attributeName: string,
): string[] {
  const dataClassName = dataClass.name()!
  return values[dataClassName]?.[attributeName] || []
}

export function provideAttributeLocalizers(
  locale: string,
  dataClass: DataClass,
  localizersByAttribute: Record<string, Record<string, string>>,
): void {
  const localeLocalizers = (localizers[locale] ||= {})
  localeLocalizers[dataClass.name()!] = localizersByAttribute
}

export function localizeAttributeValue({
  dataClass,
  attributeName,
  attributeValue,
}: {
  dataClass: DataClass
  attributeName: string
  attributeValue: string
}): string {
  const language = i18n.resolvedLanguage ?? 'en'
  const dataClassName = dataClass.name()!
  const localizedValue =
    localizers[language]?.[dataClassName]?.[attributeName]?.[attributeValue]
  const enValue =
    localizers['en']?.[dataClassName]?.[attributeName]?.[attributeValue]

  return localizedValue ?? enValue ?? attributeValue
}
